<template>
  <v-row class="pa-4">
    <v-col cols="12" md="4">
      <vs-card data-test="welcome-card" :title="name">
        <div>
          <vs-text type="caption">
            <span data-test="email-value">{{ email }}</span>
            <span v-if="email"> &#183; </span>
            <span data-test="role-value">{{ currentUserRole }}</span>
          </vs-text>
          <vs-text data-test="role-scope" type="caption">{{ displayedScope }}</vs-text>
        </div>
        <vs-button
          data-test="change-password-button"
          label="Change Password"
          full-width
          type="secondary"
          :disabled="isChangePasswordDisabled"
          :loading="isChangePasswordLoading"
          @click="changePasswordClicked"
        />
      </vs-card>
    </v-col>

    <v-snackbar v-model="isSnackbarVisible" data-test="password-changed-snackbar" bottom>
      {{ snackbar.messages[snackbar.messageKey] }}
      <v-btn
        data-test="password-changed-snackbar-close"
        dark
        text
        @click.native="isSnackbarVisible = false"
        >Close</v-btn
      >
    </v-snackbar>
  </v-row>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { getInstance } from '@/auth/auth.js'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Home',

  data() {
    return {
      snackbar: {
        messageKey: 'changePasswordRequestSent',
        messages: {
          changePasswordRequestSent:
            'An email with a link to change your password should arrive in your inbox shortly.',
        },
      },
      isSnackbarVisible: false,
      isChangePasswordDisabled: false,
      isChangePasswordLoading: false,
    }
  },

  computed: {
    ...mapGetters({
      currentUserContext: 'permissions/getContext',
      isGlobalAdmin: 'permissions/isGlobalAdmin',
    }),
    name(): string {
      const name = this.currentUserContext.name
      if (name != null) return name

      if (this.isGlobalAdmin) {
        return 'Global Admin'
      }

      return ''
    },
    email(): string {
      return this.currentUserContext.email
    },
    currentUserRole(): string {
      return this.currentUserContext.displayedRole
    },
    displayedScope(): string {
      const scopes = new Set(
        this.currentUserContext.roleAssignments.map((ra) => ra.BusinessUnitName),
      )

      return [...scopes].join(' | ')
    },
  },
  methods: {
    async changePasswordClicked() {
      this.isChangePasswordLoading = true

      const authService = getInstance()
      const promise = authService.requestPasswordReset()

      this.snackbar.messageKey = 'changePasswordRequestSent'
      this.isSnackbarVisible = true
      this.isChangePasswordLoading = false
      this.isChangePasswordDisabled = true

      await promise
    },
  },
})
</script>
